declare global {
  // tslint:disable-next-line
  interface Window {
    jQuery: JQueryStatic;
    $: JQueryStatic;
  }
}

const $ = window.$

export { $ }
